import { createPortal } from 'react-dom';
import { motion } from 'motion/react';
import { X, Maximize } from 'lucide-react';
import styles from './FullScreenChartModal.module.css';

export function FullScreenChartModal({ onClose, title, children }) {
  const modalContent = (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`${styles.modalOverlay} mc-scope`}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0, y: 10 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.95, opacity: 0, y: 10 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title} - Vista Espansa</h2>
          <button onClick={onClose} className={styles.closeBtn}>
            <X size={22} color="#1a1a2e" />
          </button>
        </div>
        <div className={styles.modalBody}>
          {children}
        </div>
      </motion.div>
    </motion.div>
  );

  // Use a portal so the fixed positioning isn't trapped by transform/animate properties in parents
  return createPortal(modalContent, document.body);
}

export function ExpandButton({ onClick }) {
  return (
    <button className={styles.expandBtn} onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }}>
      <Maximize size={16} color="#666666" />
    </button>
  );
}
